import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Icon10 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon9 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/yahaya.jpeg";

import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/joanne.webp";
import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/liyide.webp";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const blockchainDeveloperProgram = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Blockchain Developer Bootcamp",
  description: `
  In this program, you will explore the knowledge dynamics of blockchain technology, 
  and develop solutions for blockchain platforms. Create your own private blockchain, 
  and secure a digital asset using blockchain identity. Explore the Ethereum 
  platform, and use Solidity and smart contracts to develop your own decentralized app.
    `,
  duration: "6 Months",

  //   downloadBrochureUrl:
  //     "https://drive.google.com/file/d/1psPA2EFEigkffYS2m0zqDXaApHrT3jbn/view",

  courseFormUrl: "courses/blockchain-developer-bootcamp/fill-form",

  jobTitle: "Blockchain Developer",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: Testimony2,
    name: "Ajibola Liyide",
    role: "Internal, External and Media Relations",
    testimony: `
    The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in 
    my office. Inspiring because I have learnt a lot so far. The key point 
    is that the user experience is the most important factor to add value and 
    provide solutions. `,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Become a Blockchain Developer`,
    desc: `
    The global demand for blockchain developers is growing so fast and Utiva’s learning program is designed to help you get into this space. 
    In this program, you'll work with the Bitcoin and Ethereum protocols, work on real projects from the Utiva partners and execute real-world 
    applications, and gain the essential skills for a career in this dynamic space.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Blockchain Fundamentals",
      unitTag: "Ethereum, Bitcoin",
      unitDescription: `
      There is a need to understand different blockchains and their working – Ethereum, Bitcoin, Neo, and Hyperledger being the most important ones. 
      Learn the basics of how the blockchain data model works by creating your own private blockchain using Node.js and Leveldb.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Understand what is blockchain",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Advanced blockchain security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Blockchain application",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Blockchain integration",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Blockchain advantages and limitations as well as challenges ",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Data structures and databases",
      unitTag: "DA",
      unitDescription: `
      You will learn to configure the blockchain network appropriately as per requirement 
      and therefore must understand the various and thus the best database and data structures for the target network.
        `,

      unitFeatures: [],
    },
    {
      unitId: 3,
      unitTitle: "Ethereum Smart Contracts, Tokens and Dapps",
      unitTag: `Smart Contracts, Tokens`,
      unitDescription: `
      Advance your blockchain skillset to the second generation of 
      blockchain services with smart contracts utilizing the Ethereum network.
          `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Understanding of smart contract platforms ",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "How to apply smart contract ",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Understanding types of smart contracts and how to develop them.",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Blockchain Architecture",
      unitTag: ``,
      unitDescription: `Learn blockchain architecture and advanced concepts such as privacy, security and decentralized file management. `,

      unitFeatures: [],
    },
    {
      unitId: 5,
      unitTitle: "Dapp with autonomous smart contracts and oracles",
      unitTag: ``,
      unitDescription: `
      Advance your blockchain skill set by developing a decentralized 
      application (Dapp) that will perform actions based on external triggers and handle payments.
        `,

      unitFeatures: [],
    },
    {
      unitId: 6,
      unitTitle: "Build a DEX Using JavaScript [Programming for Beginners]",
      unitTag: `HTML, CSS, Javascript`,
      unitDescription: `We understand that to be a Web3 developer, you have to start with building your programming skills. The 
        Utiva Blockchain program will introduce you to programming, and show you how to build your own DEX using JavaScript, HTML, 
        CSS. After this course, you'll be ready to dive deeper into Web3 development.`,

      unitFeatures: [],
    },
    {
      unitId: 7,
      unitTitle: "What's a BlockHeader and how to building one",
      unitTag: `Fundamental knowledge of Blockheader, Understanding the structure of a Block`,
      unitDescription: `Block Header - is a type of header that is used to identify certain blocks inside a blockchain network. 
        A block header is used to identify specific blocks within a blockchain network. 
        Each block has unique heather to aid with the monitoring of protocol changes. Moreover, 
        the block is hashed repeatedly to create proof-of-work mining rewards.`,
      unitFeatures: [],
    },
    {
      unitId: 8,
      unitTitle: "Building a Mining Module",
      unitTag: `Building a Mining Module, Implementation of core modules with the Blockchain Module`,
      unitDescription: `Block Header - is a type of header that is used to identify certain blocks inside a blockchain network. 
          A block header is used to identify specific blocks within a blockchain network. 
          Each block has unique heather to aid with the monitoring of protocol changes. Moreover, 
          the block is hashed repeatedly to create proof-of-work mining rewards.`,
      unitFeatures: [],
    },
    {
      unitId: 9,
      unitTitle: "Capstone",
      unitTag: ``,
      unitDescription: `For your capstone project, you’ll use all the new skills you’ve acquired to build decentralized property listing application`,

      unitFeatures: [],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Josiah Yahaya",
      coachRole: "Senior Blockchain Engineer, Dedicated.Ai",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Hands On Training",
      modelDescription:
        "Practical sessions with lots of collaboration and learnings",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Virtual Classes",
      modelDescription:
        "A 6 months experiential learning and hands-on Instructor-led virtual classes.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Business Case-focused",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Peer-to-Peer Sessions",
      modelDescription:
        "Share knowledge with other fellows and gain multi-dimensional perspectives of problem-solving",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: Testimony1,
      firstname: "Joanne",
      lastname: "Osuchukwu",
      company: "Blockchain Developer Fellow",
      testimony: `
      The utiva learning environment is impressive because I like the improved class interactions 
      that come with the smaller cohort size. I also benefit from the flexibility of online education, 
      as well as, the real-time learning with colleagues who absolutely improve the experience. Shoutout 
      to Project Adesso, who provided me with the scholarship. It's been a great experience so far.
      `,
    },
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Ajibola",
      lastname: "Liyide",
      company: "Internal, External and Media Relations",
      testimony: `
        The Utiva training with Utiva has been challenging and inspiring. Challenging 
        because it is at the same time as the re-branding project in my office. Inspiring because 
        I have learnt a lot so far. The key point is that the user experience is the most 
        important factor to add value and provide solutions. 
        `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases",
    description: `
    Through the Utiva Blockchain Developer Bootcamp, you will learn what 
    makes competent Blockchain Developer and work on real-world projects 
    developed by industry experts. Every week in your Utiva Blockchain Developer Bootcamp classes, 
    you'll be provided with clear actionable steps to iteratively develop your 
    project. With real-world projects and immersive content built in partnership 
    with top-tier companies, you’ll master the skills companies require. 
      `,
    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Blockchain Developer Bootcamp Certification",
    description: `
    Upon completing Utiva's Blockchain Developer Bootcamp, you'll receive an 
    industry-recognized, professional Blockchain Developer Program certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",
  videoTestimonial: "https://www.youtube.com/embed/laXCECv00ww",

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
